import { getCheckout, State as CheckoutState } from "./checkout";
import { PaymentMethod } from "../../../../../constants";
import { ICartItemWithBundleId } from "../../../../../models";
import { PaymentSelected, PaymentState } from "../../../../../models/state";
import { getItemByBundleId } from "./cartSelectors";

export type State = CheckoutState;
export const getPayment: (state: State) => PaymentState = (state) => getCheckout(state).payment || {};
export const getPaymentSuccessRedirectUrl: (state: State) => string = (state) =>
    getPayment(state).paymentSuccessRedirectUrl || "";
export const getPaymentSuccessRedirectAction: (state: State) => any = (state) =>
    getPayment(state).paymentSuccessRedirectAction;
export const getPaymentMethods: (state: State) => PaymentMethod[] = (state) => getPayment(state).methods || [];
export const getPaymentSelected: (state: State) => Partial<PaymentSelected> = (state) =>
    getPayment(state).selected || {};
export const getPaymentSelectedType: (state: State) => PaymentMethod | undefined = (state) =>
    getPaymentSelected(state).type;
export const isLeaseError: (state: State) => boolean = (state) => !!getPayment(state).isLeaseError;
export const getLeaseErrorCartItemId: (state: State) => string | undefined = (state) =>
    getPayment(state).leaseErrorCartItemId;
export const getLeaseErrorCartItem: (state: State) => ICartItemWithBundleId | undefined = (state) => {
    const leaseErrorCartItemId = getLeaseErrorCartItemId(state);

    return leaseErrorCartItemId ? getItemByBundleId(state, leaseErrorCartItemId)[0] : undefined;
};
export const showDelayOnPurchaseModal: (state: State) => boolean = (state) =>
    !!getPayment(state).showDelayOnPurchaseModal;
